<template>
  <div class="el-single-select single-select-wrap">
    <el-dialog
      :before-close="handleClose"
      :close-on-click-modal="false"
      title="集团公司名称"
      :visible.sync="visible"
      v-if="visible"
      width="1000px"
    >
      <div class="el-dialog-box">
        <div class="dialog-top">
          <slot name="dialogTop">
            <div class="dialog-input">
              <span class="label">公司名称：</span>
              <el-input
                v-model="formData.supName"
                placeholder="请输入集团公司名称模糊查询"
                clearable
              />
            </div>
            <div class="dialog-btn">
              <el-button
                size="mini"
                type="primary-font-mini"
                @click="singleSearch"
                >搜索<!--搜索--></el-button
              >
              <el-button size="mini" type="default-mini" @click="handleReset"
                >重置<!--重置--></el-button
              >
            </div>
          </slot>
        </div>
        <div class="dialog-bottom">
          <el-table
            ref="multipleTable"
            :data="companyList"
            border
            :fit="true"
            tooltip-effect="dark"
            max-height="390"
            style="width: 100%"
            v-if="visible"
          >
            <!--序号-->
            <el-table-column label="序号" type="index" width="55" />
            <el-table-column
              show-overflow-tooltip
              label="公司名称"
              prop="supName"
            />
            <!--操作-->
            <el-table-column label="操作" width="100" fixed="right">
              <template slot-scope="{ row }">
                <el-button
                  class="row-btn"
                  plain
                  type="single-number"
                  @click="checkDetail(row)"
                  >选择<!--选择-->
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="dialog-footer" slot="footer" v-show="companyList.length > 0">
        <div id="ccui-paging">
          <el-pagination
            :total="total"
            :page-size="pageSize"
            :current-page="pageNo"
            prev-text="< 上一页"
            next-text="下一页 >"
            background
            :page-sizes="[10, 20, 50, 100, 200, 500]"
            layout="total, sizes, prev, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @prev-click="handlePrev"
            @next-click="handleNext"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
          <el-button class="ccui-pagination-btn" size="mini" type="default"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { companyList } from "../api/supRegister";
export default {
  name: "singleSupplier",
  data() {
    return {
      visible: false,
      pageNo: 1,
      pageSize: 10,
      total: 0,
      companyList: [],
      formData: {
        supName: ""
      }
    };
  },
  activated() {
    this.getCompanyList();
  },
  deactivated() {
    this.initDatda();
  },
  mounted() {
    this.getCompanyList();
  },
  methods: {
    initDatda() {
      this.visible = false;
      this.pageNo = 1;
      this.pageSize = 10;
      this.total = 0;
      this.formData = { supName: "" };
    },
    //获取列表数据
    getCompanyList() {
      let param = {};
      param = typeof this.formData == "object" ? this.formData : {};
      param.abroadFlag = "0";
      param.pageNo = this.pageNo;
      param.pageSize = this.pageSize;
      companyList(param)
        .then(res => {
          this.companyList = res.data.data.rows;
          this.total = res.data.data.total;
        })
        .catch(error => {});
    },
    singleSearch() {
      this.getCompanyList();
    },
    handleReset() {
      this.formData = { supName: "" };
    },
    handleClose() {
      this.initDatda();
    },
    checkDetail(row) {
      this.$emit("selectedSupplier", row);
      this.initDatda();
    },
    handlePrev() {
      console.log("上一页");
    },
    handleNext() {
      console.log("下一页");
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      val !== "none" && (this.pageSize = val) && (this.pageNo = 1);
      this.getCompanyList();
    },
    handleCurrentChange(val) {
      // 跳转翻页都会调这个方法
      this.pageNo = val;
      this.getCompanyList();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../css/index.scss";  
.chooseSettle {
  display: inline-block;
}
.single-select-wrap /deep/ .el-dialog__wrapper .el-dialog {
  /*height: 85% !important;*/
  /*min-height: 570px;*/
  .el-dialog__body {
    /*height: 70vh !important;*/
    height: 480px !important;
    overflow: inherit !important;
    .el-dialog-box {
      height: 100% !important;
      overflow: inherit !important;
      .dialog-bottom {
        height: 66%;
        .el-table .cell {
          &.el-tooltip {
            white-space: inherit;
          }
          .row-btn {
            width: auto !important;
            padding: 0 20px !important;
            margin-left: 0 !important;
            border-color: #ff142f;
            background: none;
          }
        }
      }
    }
    .el-button.el-button--single-number span {
      color: #ff142f;
    }
    .el-dialog-box .dialog-top {
      .dialog-input {
        .label {
          display: inline-block;
          width: 170px !important;
          text-align: right;
        }
        .el-input {
          width: 260px;
        }
      }
      .dialog-btn {
        width: 100%;
        display: flex;
        justify-content: center;
      }
      .el-input-group--append {
        .el-button {
          background: #f7f9ff;
          border: 1px solid;
          &:hover {
            background-color: #fff;
            border-color: #5576cf;
            color: #fff;
          }
          span {
            font-size: 13px;
            font-weight: 500;
          }
        }
      }
    }
  }
  .el-dialog__footer {
    border-top: none;
    padding: 0 30px !important;
  }
}
/*/deep/.el-table--scrollable-y .el-table__body-wrapper{*/
/*max-height:350px!important*/
/*}*/
</style>
